import { render, staticRenderFns } from "./PlaylistCreationPage.vue?vue&type=template&id=f98f9880&scoped=true&"
import script from "./PlaylistCreationPage.vue?vue&type=script&lang=js&"
export * from "./PlaylistCreationPage.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistCreationPage.vue?vue&type=style&index=0&id=f98f9880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f9880",
  null
  
)

export default component.exports